import {
  ClientContextResponse,
  CustomerUpdatePayload,
} from '@ancon/wildcat-types'
import getSHA256Hash from '@ancon/wildcat-utils/hashing/getSHA256Hash'

import api from '../../../api'
import createAppAsyncThunk from '../../../store/createAppAsyncThunk'
import { ExtendedCustomerUserDetails } from '../types'

import { clientContextCustomerIdSelector } from './clientContextSelectors'

export const fetchCustomerDetails = createAppAsyncThunk<
  ExtendedCustomerUserDetails,
  string
>('clientContext/fetchCustomerDetails', async customerId => {
  try {
    const response = await api.user.customers.get.details({
      customerId,
    })
    const { customer } = response.data

    // Get customer email hash if email exists
    let emailHash = null
    if (customer.email) {
      emailHash = await getSHA256Hash(customer.email)
    }

    return { ...customer, emailHash }
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error(err)
    throw err
  }
})

export const fetchClientContext = createAppAsyncThunk<
  ClientContextResponse | null,
  | {
      backgroundFetch?: boolean
    }
  | undefined
>('clientContext/fetchClientContext', async (_, { dispatch }) => {
  const response = await api.core.clientContext.get.details()

  const clientContext = response?.data

  const customer = clientContext?.customer

  if (customer?.email) {
    await dispatch(fetchCustomerDetails(customer.customerUserId))
  }

  return clientContext || null
})

export const updateCustomerDetails = createAppAsyncThunk<
  void,
  CustomerUpdatePayload
>('clientContext/updateCustomerDetails', async (customerData, { getState }) => {
  try {
    const customerId = clientContextCustomerIdSelector(getState())

    if (customerId) {
      await api.user.customers.put.byId(customerData, { customerId })
    }
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error(err)
    throw err
  }
})

export const activateCustomer = createAppAsyncThunk<void, { email: string }>(
  'auth/activateCustomer',
  async ({ email }, { getState }) => {
    try {
      const customerId = clientContextCustomerIdSelector(getState())

      if (customerId) {
        await api.user.customers.put.activate({ email }, { customerId })
      }
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error(err)
      throw err
    }
  },
)
